import React, { useEffect, useRef, useState } from "react";
import { withSnackbar } from "notistack";
import { IconButton, Tooltip } from "@mui/material";
import { Edit as IconEdit } from "@mui/icons-material";

import TxtBox from "components/Custom/TxtBox";
import UiDialog from "components/Custom/UiDialog";
import RadioBtn from "components/Custom/RadioBtn";
import Btn from "components/Custom/Btn";
import SwitchBtn from "components/Custom/SwitchBtn";
import AutoComplete from "components/Custom/AutoComplete";
import Loader from "components/Custom/Loader";
import ExcelGrid from "components/Custom/ExcelGrid";

import { ApiMasters } from "apihandlers//masters/masters";
import { NOTIFY, DEFAULTS } from "common/config";
import { COLORS } from "common/colors";
import {
  ERRORS,
  LABELS,
  SUCCESS,
  WARNINGS,
  TITLES,
  SUB_TITLES,
} from "common/labels";
import { COMMON_JS } from "common/scripts";
import { ApiLogin } from "apihandlers/login";

const ApiMastersHandler = new ApiMasters();
const ApiLoginHandler = new ApiLogin();

const Users = (props: any) => {
  const { setDashMenu } = props;
  const userTypeRef: any = useRef(null);

  const [loading, setLoading] = useState(true);
  const [isSubmit, setIsSubmit] = useState(false);
  const [rows, setRows] = useState<any>(null);
  const [userTypes, setUserTypes] = useState<any>(null);
  const [manageDialog, setManageDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [mandatoryResults, setMandatoryResults] = useState<any[]>([]);

  useEffect(() => {
    if (loading) {
      getUserType();
    }
  }, [loading]);

  const getRows = async () => {
    try {
      const args = {
        pageNo: 1,
        pageLength: DEFAULTS.PAGE_LENGTH,
      };
      const res: any = await ApiLoginHandler.getUserProfile(args);
      const { status, response } = res;
      if (status === 200) {
        let list = response.records;
        for (let i = 0; i < response.records.length; i++) {
          list[i]["slNo"] = i + 1;
          if (list[i]["activeStatus"]) {
            list[i]["activeStatusText"] = "Yes";
          } else {
            list[i]["activeStatusText"] = "No";
          }
          list[i]["locationStatusText"] = list[i]["locationStatus"]
            ? "Yes"
            : "No";
          list[i]["verifiedText"] = list[i]["verified"] ? "Yes" : "No";
        }
        setRows(list);
        setLoading(false);
      }
    } catch (error) {
      console.error("getUserTypes:", error);
    }
  };

  const getUserType = () => {
    const args = {
      minResponse: true,
    };
    ApiMastersHandler.getUserType(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.name,
          };
        });
        setUserTypes(list);
        getRows();
      }
    });
  };

  const onEditRow = (row: any) => {
    setSelectedRow(row);
    setManageDialog(true);
    console.log(selectedRow);
  };

  const COLUMNS = [
    {
      key: "slNo",
      name: LABELS.SL_NO,
      width: "5%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
    },
    {
      key: "userName",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.USER_NAME,
      width: "15%",
    },
    {
      key: "mobileNo",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.MOBILE_NO,
      width: "15%",
    },
    {
      key: "emailId",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.EMAIL_ID,
      width: "15%",
    },
    {
      key: "typeName",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.USER_ROLE,
      width: "15%",
    },
    {
      key: "locationStatusText",
      type: "dropdown",
      filters: [
        {
          id: "yes",
          name: "Yes",
        },
        {
          id: "no",
          name: "No",
        },
      ],
      name: LABELS.TRACK_LOCATION,
      width: "10%",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "activeStatusText",
      type: "dropdown",
      filters: [
        {
          id: "yes",
          name: "Yes",
        },
        {
          id: "no",
          name: "No",
        },
      ],
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.ACTIVE,
      width: "10%",
    },
    {
      key: "verifiedText",
      type: "dropdown",
      filters: [
        {
          id: "yes",
          name: "Yes",
        },
        {
          id: "no",
          name: "No",
        },
      ],
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.VERIFY,
      width: "10%",
    },
    {
      key: "options",
      name: LABELS.OPTIONS,
      width: "5%",
      renderCell: (params) => (
        <div className="options">
          <Tooltip title={LABELS.EDIT} placement="bottom">
            <IconButton
              className="iconBtn"
              onClick={() => onEditRow(params.row)}
            >
              <IconEdit />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];

  const manageUserProfile = () => {
    const userName = (
      document.getElementById("userName") as HTMLInputElement
    ).value.trim();
    const userTypeId = userTypeRef.current.selectedValue.id;
    const firstName = (
      document.getElementById("firstName") as HTMLInputElement
    ).value.trim();
    const lastName = (
      document.getElementById("lastName") as HTMLInputElement
    ).value.trim();
    const mobileNo = (
      document.getElementById("mobileNo") as HTMLInputElement
    ).value.trim();
    const emailId = (
      document.getElementById("emailId") as HTMLInputElement
    ).value.trim();
    const password = (
      document.getElementById("password") as HTMLInputElement
    ).value.trim();
    let track = document.querySelector(
      'input[name="locationStatus"]:checked'
    ) as HTMLInputElement;
    const locationStatus = track ? track.value : "";
    const active = document.querySelector(
      'input[name="activeStatus"]:checked'
    ) as HTMLInputElement;
    const selectBtnValue = active ? active.value : "";
    const verify = document.querySelector(
      'input[name="verified"]:checked'
    ) as HTMLInputElement;
    const verified = verify ? verify.value : "";
    // Validations
    // if (!userName) {
    //   COMMON_JS.showNotify(props, NOTIFY.WARNING, WARNINGS.MANDATORY);
    //   return;
    // }
    // // if (!password) {
    // //   COMMON_JS.showNotify(props, NOTIFY.WARNING, WARNINGS.MANDATORY);
    // //   return;
    // // }
    // if (!firstName) {
    //   COMMON_JS.showNotify(props, NOTIFY.WARNING, WARNINGS.MANDATORY);
    //   return;
    // }
    // if (!mobileNo) {
    //   COMMON_JS.showNotify(props, NOTIFY.WARNING, WARNINGS.MANDATORY);
    //   return;
    // }
    // if (!selectBtnValue) {
    //   COMMON_JS.showNotify(props, NOTIFY.WARNING, WARNINGS.MANDATORY);
    //   return;
    // }
    // if (!password) {
    //   COMMON_JS.showNotify(props, NOTIFY.WARNING, WARNINGS.MANDATORY);
    //   return;
    // }

    let errors = [];
    if (firstName == "") {
      errors.push({
        id: "firstName",
        msg:
          "<span class='bold'>" +
          LABELS.FIRST_NAME +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (firstName.length < 3) {
      errors.push({
        id: "firstName",
        msg:
          "<span class='bold'>" +
          LABELS.FIRST_NAME +
          "</span> " +
          WARNINGS.MIN_CHAR_REQUIRED_FIELD,
      });
    }
    if (userName == "") {
      errors.push({
        id: "userName",
        msg:
          "<span class='bold'>" +
          LABELS.USER_NAME +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (!userTypeId) {
      errors.push({
        id: "typeId",
        msg:
          "<span class='bold'>" +
          LABELS.USER_ROLE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (mobileNo == "") {
      errors.push({
        id: "mobileNo",
        msg:
          "<span class='bold'>" +
          LABELS.MOBILE_NO +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (emailId == "") {
      errors.push({
        id: "emailId",
        msg:
          "<span class='bold'>" +
          LABELS.EMAIL_ID +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (password == "") {
      errors.push({
        id: "password",
        msg:
          "<span class='bold'>" +
          LABELS.PASSWORD +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }

    if (!active) {
      errors.push({
        id: "activeStatus",
        msg:
          "<span class='bold'>" +
          LABELS.ACTIVE_STATUS +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (!verified) {
      errors.push({
        id: "verified",
        msg:
          "<span class='bold'>" +
          LABELS.VERIFIED_STATUS +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    setMandatoryResults(errors);
    if (errors.length > 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_CHECK_FORM_ERRORS
      );
      return;
    }

    const args = {
      id: selectedRow.id || -1,
      userName,
      firstName,
      lastName,
      mobileNo,
      emailId,
      password,
      userTypeId,
      locationStatus: locationStatus.toString(),
      activeStatus: selectBtnValue.toString(),
      verified: verified.toString(),
    };
    setIsSubmit(true);
    ApiLoginHandler.manageUserProfile(args).then((res) => {
      setIsSubmit(false);
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
        setSelectedRow({});
        setManageDialog(false);

        reloadGrid();
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
      }
    });
  };

  const reloadGrid = () => {
    setRows(null);
    getRows();
  };

  const onAdd = () => {
    setSelectedRow({});
    setManageDialog(true);
  };

  console.log("selectedRow", selectedRow);

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li onClick={() => setDashMenu("")}>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li onClick={() => setDashMenu(LABELS.HOME)}>{LABELS.MASTERS} </li>
          <li className="dim">{" / "}</li>
          <li className="active">{TITLES.USERS}</li>
        </ul>
        <h4>{TITLES.USERS}</h4>
        <p className="SubTitles">{SUB_TITLES.USERS}</p>
      </div>

      <div className="grid excelGridWrapper">
        {rows ? (
          <ExcelGrid
            id={LABELS.USERS}
            height={window.innerHeight * 0.8}
            cols={COLUMNS}
            rows={rows}
            exportOption={true}
            newRowOption={false}
            exportName={LABELS.USERS}
            onReload={reloadGrid}
            onAdd={onAdd}
          />
        ) : (
          <div className="flexRowCenter">
            <Loader />
          </div>
        )}
      </div>

      {manageDialog && (
        <UiDialog
          title={
            selectedRow.id
              ? "Edit " + TITLES.USER + ": " + selectedRow.userName
              : "Add New " + TITLES.USER
          }
          open={true}
          size={"sm"}
          onClose={() => {
            setManageDialog(false);
            setMandatoryResults([]);
          }}
        >
          <div className="formGroup red">
            <label>{LABELS.FIRST_NAME}</label>
            {<span className="red">{"*"}</span>}
            <TxtBox
              id={"firstName"}
              placeholder={LABELS.FIRST_NAME}
              defaultValue={selectedRow.firstName}
              disabled={isSubmit}
            />
          </div>
          <div className="formGroup">
            <label>{LABELS.LAST_NAME}</label>
            <TxtBox
              id={"lastName"}
              placeholder={LABELS.LAST_NAME}
              defaultValue={selectedRow.lastName}
              disabled={isSubmit}
            />
          </div>
          <div className="formGroup red">
            <label>
              {LABELS.USER_NAME}
              {<span>{" *"}</span>}
            </label>
            <TxtBox
              id={"userName"}
              placeholder={LABELS.USER_NAME}
              defaultValue={selectedRow.userName}
              disabled={isSubmit}
            />
          </div>
          <div className="formGroup red">
            <label>
              {LABELS.USER_ROLE}
              {<span>{" *"}</span>}
            </label>
            <AutoComplete
              list={userTypes}
              childRef={userTypeRef}
              defaultValue={
                selectedRow.id
                  ? {
                      id: selectedRow.typeId,
                      label: selectedRow.typeName,
                    }
                  : null
              }
              onChange={(e, v) => {}}
              disabled={isSubmit}
            />
          </div>
          <div className="formGroup red">
            <label>
              {LABELS.MOBILE_NO} {<span>{" *"}</span>}
            </label>
            <TxtBox
              id={"mobileNo"}
              placeholder={LABELS.MOBILE_NO}
              defaultValue={selectedRow.mobileNo}
              disabled={isSubmit}
            />
          </div>
          <div className="formGroup red">
            <label>
              {LABELS.EMAIL_ID}
              {<span>{" *"}</span>}
            </label>
            <TxtBox
              id={"emailId"}
              placeholder={LABELS.EMAIL_ID}
              defaultValue={selectedRow.emailId}
              disabled={isSubmit}
            />
          </div>
          <div className="formGroup required red">
            <label>
              {LABELS.PASSWORD} {<span>{" *"}</span>}
            </label>
            <TxtBox
              id={"password"}
              type="password"
              placeholder={LABELS.PASSWORD}
              defaultValue={selectedRow.password}
              disabled={isSubmit}
            />
          </div>
          <div className="formGroup">
            <label>{LABELS.TRACK_LOCATION + " ?"}</label>
            <RadioBtn
              list={[
                {
                  id: "locationStatusYes",
                  value: "true",
                  label: LABELS.YES,
                  checked: selectedRow.id
                    ? selectedRow.locationStatus === true
                    : false,

                  disabled: false,
                },
                {
                  id: "locationStatusNo",
                  value: "false",
                  label: LABELS.NO,
                  checked: selectedRow.id
                    ? selectedRow.locationStatus === false
                    : true,
                  disabled: false,
                },
              ]}
              name={"locationStatus"}
              row={true}
              disabled={isSubmit}
            />
          </div>
          <div className="formGroup required red">
            <label>
              {LABELS.ACTIVE_STATUS} {<span>*</span>}
            </label>
            <RadioBtn
              list={[
                {
                  id: "activeYes",
                  value: "true",
                  label: LABELS.ACTIVE,
                  checked: selectedRow.id
                    ? selectedRow.activeStatus === true
                    : true,
                  disabled: false,
                },
                {
                  id: "activeNo",
                  value: "false",
                  label: LABELS.INACTIVE,
                  checked: selectedRow.id
                    ? selectedRow.activeStatus === false
                    : false,
                  disabled: false,
                },
              ]}
              row={true}
              name={"activeStatus"}
              disabled={isSubmit}
            />
          </div>
          <div className="formGroup required red">
            <label>
              {LABELS.VERIFIED_STATUS} {<span>*</span>}
            </label>
            <RadioBtn
              list={[
                {
                  id: "verifiedYes",
                  value: "true",
                  label: LABELS.VERIFY,
                  checked: selectedRow.id
                    ? selectedRow.verified === true
                    : true,
                  disabled: false,
                },
                {
                  id: "verifiedNo",
                  value: "false",
                  label: LABELS.NOTVERIFY,
                  checked: selectedRow.id
                    ? selectedRow.verified === false
                    : false,
                  disabled: false,
                },
              ]}
              row={true}
              name={"verified"}
              disabled={isSubmit}
            />
          </div>

          {/* mandatoryResults */}
          {mandatoryResults.length > 0 && (
            <div className="mandatoryBox">
              <ul>
                {mandatoryResults.map((m) => {
                  return (
                    <li>
                      <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                    </li>
                  );
                })}
              </ul>
            </div>
          )}

          <div className="formGroup submitBtnWrapper">
            <div className=" flexbtnjustify">
              <Btn
                text={LABELS.CANCEL}
                // loading={isSubmit}
                bgColor={COLORS.RELOAD_EXPORT}
                color={COLORS.RELOAD_EXPORT_TEXT}
                onClick={() => {
                  setManageDialog(false);
                  setMandatoryResults([]);
                }}
              />
              <Btn
                text={LABELS.SAVE}
                loading={isSubmit}
                bgColor={COLORS.SAVE_GREEN}
                onClick={manageUserProfile}
              />
            </div>
          </div>
        </UiDialog>
      )}
    </React.Fragment>
  );
};

export default withSnackbar(Users);
